module.exports = __webpack_public_path__ + "fonts/iconfont.441cc9e4.ttf";